"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRefillRequestUnregistered = exports.useRefillRequestRegistered = void 0;
var react_query_1 = require("react-query");
var refillRequest_1 = require("liberty-core/api/refillRequest");
function useRefillRequestRegistered(options) {
    var queryClient = (0, react_query_1.useQueryClient)();
    return (0, react_query_1.useMutation)(refillRequest_1.postRefillRequest, __assign(__assign({}, options), { onSuccess: function (_, _a) {
            var scriptNumbers = _a.scriptNumbers;
            return queryClient.invalidateQueries(["prescription", scriptNumbers[0]]);
        } }));
}
exports.useRefillRequestRegistered = useRefillRequestRegistered;
function useRefillRequestUnregistered(options) {
    return (0, react_query_1.useMutation)(refillRequest_1.postRefillRequestUnregistered, options);
}
exports.useRefillRequestUnregistered = useRefillRequestUnregistered;
